export const templateKey = {
    // Make sure that the order remains same: 1. Pick up 2. Delivery. 
    // The first item is server restaurant object is always for pick up template and 2nd one is for delivery templateF
    pickUp: "PICK_UP",
    delivery: "DELIVERY",
}

export const defaultEmailTemplateObject = () => ({
    headerImage: null,
    headerBgColor: null,
    headerTitle: "",
    headerTitleColor: null,
    headerSubTitle: "",
    headerSubTitleColor: null,
    helpText: "",
    collectionInformationHeading: "",
    collectionInformationText: "",
    footerImage: null,
    footerBgColor: null,
    footerTitle: "",
    footerTitleColor: null,
    footerSubTitle: "",
    footerSubTitleColor: null,
});

export const initialState = {
    onlineOrder: false,
    deliveryWindowStartTime: "",
    deliveryWindowEndTime: "",
    takeAwayWindowStartTime: "",
    takeAwayWindowEndTime: "",
    minimumCollectionOrderAmount: "",
    minimumDeliveryOrderAmount: "",
    isDeliveryEnabled: false,
    isTakeAwayEnabled: false,
    busyMode: false,
    busyModeTime: 0,
    defaultBusyModeTime: "",
    deliveryRadius: "",
    deliveryETA: "",
    diningETA: "",
    [templateKey.pickUp]: defaultEmailTemplateObject(),
    [templateKey.delivery]: defaultEmailTemplateObject(),
};

// action has the following structure: {type: "field name / key", payload: "value" or { value, subField}}
export const reducer = (state, action) => {
    switch (action.type) {
        case "STATE": return action.payload;
        case templateKey.pickUp:
        case templateKey.delivery:
            switch (action.payload.subField) {
                case "headerImage":
                    return {
                        ...state,
                        [action.type]: {
                            ...state[action.type],
                            [action.payload.subField]: action.payload.value,
                            headerBgColor: null,
                        }
                    };
                case "footerImage":
                    return {
                        ...state,
                        [action.type]: {
                            ...state[action.type],
                            [action.payload.subField]: action.payload.value,
                            footerBgColor: null,
                        }
                    };
                case "headerBgColor":
                    return {
                        ...state,
                        [action.type]: {
                            ...state[action.type],
                            [action.payload.subField]: action.payload.value,
                            headerImage: null,
                        }
                    };
                case "footerBgColor":
                    return {
                        ...state,
                        [action.type]: {
                            ...state[action.type],
                            [action.payload.subField]: action.payload.value,
                            footerImage: null,
                        }
                    };
                default:
                    return {
                        ...state,
                        [action.type]: {
                            ...state[action.type],
                            [action.payload.subField]: action.payload.value
                        }
                    }
            };
        case "defaultBusyModeTime":
        case "minimumCollectionOrderAmount":
        case "minimumDeliveryOrderAmount":
        case "deliveryRadius":
        case "deliveryETA":
        case "diningETA":
            return {
                ...state,
                [action.type]: action.payload.replace(/[^0-9.]/g, "")
            }
        default:
            return {
                ...state,
                [action.type]: action.payload
            }
    }
};